import { useChartLayoutOrientation } from '../../../../core/components/chart-layout/hooks/useChartLayoutOrientation.js';
import { getLegendOrientation } from '../../../../core/components/chart-layout/utils/orientation.js';
import { ChartLegend } from '../../../../core/components/legend/categorical/ChartLegend.js';
import { safeGet } from '../../../../core/utils/safe-get.js';
import { useDotSeriesData } from '../../../hooks/useDotSeriesData.js';

export function DotSeriesLegend() {
  const { orientation: layoutOrientation } = useChartLayoutOrientation();
  const orientation = getLegendOrientation(layoutOrientation);
  const { seriesWithDatapoints, seriesToMetadata } = useDotSeriesData();

  const legendItems = seriesWithDatapoints.map((series) => {
    const { name, color } = safeGet(seriesToMetadata, series);

    return {
      id: series.id,
      color,
      name,
    };
  });

  return (
    <ChartLegend
      interactionsDisabled
      items={legendItems}
      orientation={orientation}
    />
  );
}
